module.exports = __webpack_public_path__ + "img/空气流量计.png";